import React,{useState,useEffect} from "react";
import styles from "./Footer.module.scss";
import FooterLogo from "../../assets/images/FooterLogo.png";
// import FooterImage from "../../assets/images/FooterImage.png";
import { NavLink } from "react-router-dom";
import { Icon } from "../../assets/Icons.tsx";

export default function Footer() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1025);



  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth <= 768);
      setIsDesktop(window.innerWidth <= 1025);


    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles.Footer}>
      <div className="container-fluid">
        <div className={styles.footerPadding}>
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-6 col-6">
            <div className={styles.logo}>
              <img src={FooterLogo} alt="FooterLogo" />
            </div>
            </div>
            <div className="col-md-6 col-sm-6 col-6 d-flex justify-content-end">
            {(isMobile && !isDesktop) && (
              <Icon name="footerSvg" width="100px" height="100px" />
            )}
            {(isTablet && !isDesktop)  && (
            <Icon name="footerSvg" width="150px" height="150px" />

            )}
            </div>
            </div>
           
            <div className={styles.links}>
            <div className='row'>
            <div className={`col-lg-9 col-md-10 ${styles.linkCol}`}>
              <div className={`para ${styles.link}`}>
                <NavLink to="/">Home</NavLink>
              </div>
              <div className={`para ${styles.link}`}>
                <NavLink to="/about-us">About Us</NavLink>
              </div>
              <div className={`para ${styles.link}`}>
                <NavLink to="/careers-with-aptech">Careers with Aptech</NavLink>
              </div>
              <div className={`para ${styles.link}`}>
                <NavLink to="/partner-with-aptech">Partner with Aptech</NavLink>
              </div>
              <div className={`para ${styles.link}`}>
                <NavLink to="/our-blogs">Our Blogs</NavLink>
              </div>
              <div className={`para ${styles.link}`}>
                <NavLink to="/contact-us">Contact Us</NavLink>
              </div>
              <div className={`para ${styles.link}`}>
                <NavLink to="/sitemap">Sitemap</NavLink>
              </div>
            </div>
            <div className="col-lg-3 col-md-2 d-flex justify-content-end">
              {isDesktop && (
              <Icon name="footerSvg" />
            )}

            </div>
            </div>

            </div>
            <div className={styles.tnc}>
              <div>
                Copyright © {new Date().getFullYear()} Aptech Ltd. All rights
                reserved.
              </div>
              <div className={styles.linksContainer}>
              <NavLink to="/disclaimer#disclaimerSection">
                  Disclaimer
                </NavLink> | {" "}
                <NavLink to="/disclaimer#privacySection">
                  Privacy Policy
                </NavLink> | {" "}
                <NavLink to="/disclaimer#profinitySection">
                Profanity Policy
                </NavLink>
              </div>
            </div>
          </div>
          {/* <div className="col-md-4">
            <div className={styles.footerImg}>
              <img src={FooterImage} alt="FooterImage" />
            </div>
          </div> */}
        </div>
        </div>
      </div>
    </div>
  );
}
